var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import styled, { css } from 'styled-components';
import { textStyle as textStyleFn, system } from 'styled-system';
import { get } from '../tools/utils';
var BaseShared = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n\n  font-family: ", ";\n  margin: 0;\n  &:focus {\n    outline: ", ";\n  }\n\n  ", ";\n"], ["\n  ", "\n\n  font-family: ", ";\n  margin: 0;\n  &:focus {\n    outline: ", ";\n  }\n\n  ", ";\n"])), function (_a) {
    var fontWeight = _a.fontWeight, fontStyle = _a.fontStyle, colors = _a.theme.colors;
    return "\n    font-weight: ".concat(fontWeight, ";\n    font-style: ").concat(fontStyle, ";\n    color: ").concat(colors['gray-900'], ";\n  ");
}, get.fonts('regular'), function (_a) {
    var outlineOnFocus = _a.outlineOnFocus;
    return outlineOnFocus ? 'inherit' : 'none';
}, system({
    overflowWrap: true,
}));
var TextBase = styled.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", ";\n  ", ";\n\n  ", "\n\n  text-transform: ", ";\n"], ["\n  ", ";\n  ", ";\n\n  ", "\n\n  text-transform: ", ";\n"])), BaseShared, textStyleFn, function (_a) {
    var theme = _a.theme, size = _a.size;
    return "\n    line-height: ".concat(theme.font.body[size].lineHeight, ";\n    font-size: ").concat(theme.font.body[size].size, ";\n  ");
}, function (_a) {
    var transformUppercase = _a.transformUppercase;
    return transformUppercase ? 'uppercase' : '';
});
var HeaderBase = styled.h1(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", ";\n\n  ", "\n"], ["\n  ", ";\n\n  ", "\n"
    /**
     * Used for body content.
     *
     * Defaults to size: 'sm', tag: 'span', weight: 'normal'
     */
])), BaseShared, function (_a) {
    var theme = _a.theme, size = _a.size;
    return "\n    line-height: ".concat(theme.font.heading[size].lineHeight, ";\n    font-size: ").concat(theme.font.heading[size].size, ";\n  ");
});
/**
 * Used for body content.
 *
 * Defaults to size: 'sm', tag: 'span', weight: 'normal'
 */
var TextBody = React.forwardRef(function (_a, ref) {
    var id = _a.id, children = _a.children, _b = _a.className, className = _b === void 0 ? '' : _b, _c = _a.outlineOnFocus, outlineOnFocus = _c === void 0 ? false : _c, tabIndex = _a.tabIndex, tag = _a.tag, size = _a.size, _d = _a.weight, weight = _d === void 0 ? 'normal' : _d, _e = _a.style, style = _e === void 0 ? 'inherit' : _e, type = _a.type, focusOnMount = _a.focusOnMount, _f = _a.overflowWrap, overflowWrap = _f === void 0 ? 'break-word' : _f, props = __rest(_a, ["id", "children", "className", "outlineOnFocus", "tabIndex", "tag", "size", "weight", "style", "type", "focusOnMount", "overflowWrap"]);
    var handleFocusOnMount = React.useCallback(function (node) {
        if (node) {
            node.focus();
        }
    }, []);
    return (React.createElement(TextBase, __assign({ fontWeight: weight, fontStyle: style, ref: focusOnMount ? handleFocusOnMount : ref, className: className, as: tag, outlineOnFocus: outlineOnFocus, transformUppercase: size === 'xs', textStyle: type, overflowWrap: overflowWrap, size: size, tabIndex: focusOnMount ? -1 : tabIndex }, (id && { id: id }), props), children));
});
// for now so we can see the props table
export var TextBodyForProps = function (props) { return props && null; };
var TextHeading = React.forwardRef(function (_a, ref) {
    var id = _a.id, children = _a.children, _b = _a.className, className = _b === void 0 ? '' : _b, _c = _a.outlineOnFocus, outlineOnFocus = _c === void 0 ? false : _c, tabIndex = _a.tabIndex, tag = _a.tag, _d = _a.size, size = _d === void 0 ? 'md' : _d, _e = _a.weight, weight = _e === void 0 ? 'bold' : _e, focusOnMount = _a.focusOnMount, dataAnchorId = _a.dataAnchorId, overflowWrap = _a.overflowWrap, _f = _a.style, style = _f === void 0 ? 'inherit' : _f, props = __rest(_a, ["id", "children", "className", "outlineOnFocus", "tabIndex", "tag", "size", "weight", "focusOnMount", "dataAnchorId", "overflowWrap", "style"]);
    var handleFocusOnMount = React.useCallback(function (node) {
        if (node) {
            node.focus();
        }
    }, []);
    return (React.createElement(HeaderBase, __assign({ fontWeight: weight, fontStyle: style, ref: focusOnMount ? handleFocusOnMount : ref, className: className, as: tag, outlineOnFocus: outlineOnFocus, overflowWrap: overflowWrap, tabIndex: focusOnMount ? -1 : tabIndex, "data-anchor-id": dataAnchorId, size: size }, (id && { id: id }), props), children));
});
// for now so we can see the props table
export var TextHeadingForProps = function (props) {
    return props && null;
};
export { TextBody, TextHeading };
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=Text.js.map